const al = {
  giga_more_info: 'Më shumë',
  giga_pay_next_plan: 'Paguaj Next+',
  giga_pay_fiber_tv: 'Paguaj Fibren & TV',
  giga_go_to_payment: 'Kryej pagesen',
  giga_link_ebill: 'https://ebill.vodafone.al/',
  giga_link_abcom: 'https://portal.abcom.al/',
  giga_location_permission: 'Na duhet leja juaj për të përdorur vendndodhjen.',
  giga_open_settings: 'Open settings',
  giga_bonus_helper_text: 'Vendos emrin dhe mbiemrin sipas kontratës së  Internetit fiks si dhe dërgo vendndodhjen.Të dhënat do ti përdorim për të verifikuar  cilësinë e shërbimit internet fiks në zonën tuaj.',
  giga_bonus_section_title: 'Të dhënat e mia',
  giga_bonus_section_data_title: 'Emri  dhe  Vendndodhja',
  giga_bonus_label_name: 'Emri',
  giga_bonus_helper_text_name: 'Shkruaj saktë emrin dhe mbiemrin',
  giga_bonus_use_my_location: 'Përdor vendndodhjen time',

  giga_bonus_send: 'Dërgo',

  giga_bonus_success: 'Urime!',
  giga_bonus_success_message: 'Sapo përfituat 100GB të vlefshme për 24 orë. Bonusi mund të përdoret si hotspot për të gjithë.\n\nFaleminderit që jeni pjesë e Vodafone!',
  giga_bonus_error_410: 'Ups, nuk je GigaFamily / GigaBusiness!',
  giga_bonus_error_message_410: 'Bonusi është i vlefshëm vetëm për pjesëtarët e GigaFamily / GigaBusiness.',
  giga_bonus_error_411: 'Urime!',
  giga_bonus_error_message_411: 'Ti ose një nga pjesëtarët e tjerë GigaFamily e ka përfituar bonusin.\n\nTë kujtojmë që ky bonus përfitohet vetëm njëherë në 24 orë.',
  giga_bonus_error_412: 'Nuk rezulton problem teknik!',
  giga_bonus_error_message_412: 'Nuk rezulton problem tektink në vendodhjen e raportuar. Ndërkohë kontollo pajisjen modem.\n\nZona do të verifikohet përsëri pas 30 mimutave. Nëse problemi vazhdon dërgo përsëri kërkesën.',
  giga_bonus_error: 'Diçka nuk shkoi siç duhet!',
  giga_bonus_error_message: 'Zona do të verifikohet përsëri pas 30 mimutave. Nëse problemi vazhdon dërgo përsëri kërkesën.\n\nNdërkohë kontollo pajisjen modem.',
  giga_bonus_get_help: 'Merr ndihmë',
  giga_bonus_go_back: 'Kthehu',
  giga_bonus_help_url: 'https://www.vodafone.al/suport/',

  giga_bonus_details_title: 'Detajet e bonusit',
  giga_bonus_details_section_1: 'Garantojmë shërbim të pandërprerë ndërkohë që i japim zgjidhje problemeve teknike.\n',
  giga_bonus_details_section_2: '100 GB  dhuratë nga Vodafone për të qënë gjithmonë të lidhur.\n',
  giga_bonus_details_item_1: 'Vetëm një nga pjesëtarët e Giga Family / GigaBusiness e përfiton.',
  giga_bonus_details_item_2: 'Ofrohet vetëm në My Vodafone App.',
  giga_bonus_details_item_3: 'Përfitohet vetëm njëherë në 24 orë.',
  giga_bonus_details_item_4: 'Është i vlefshëm për 24 orë.',
  giga_bonus_details_item_5: 'Ka prioritet ndaj ofertave të tjera internet.',

  giga_bonus_error_permission_denied: '! Nuk e ke dërguar vendndodhjen tënde. Sigurohu që të kesh aktiv Location në settings të telefonit.',
  giga_bonus_error_position_unavailable: '! Sigurohu që të kesh aktiv Location në settings të telefonit.',
  giga_bonus_error_location_timeout: '! Nuk e ke dërguar vendndodhjen tënde. Të lutem provo përsëri.',
}

export default al
